import { transformDateValue } from 'core/js/FormUtils';
export const getProductrawView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let productrawList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"rm Name","fieldValue":transformDataValue(data.rmname,"string"), "fieldType":"string"},
                            {"fieldLabel":"qty","fieldValue":transformDataValue(data.qty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Status","fieldValue":transformDataValue(data.status,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          productrawList.push(card);
  })
  return productrawList;
}